import React from 'react'
import { Layout, TwoColumns, Sidebar } from 'app/theme/layout'
import Slider from 'app/theme/slider'
import styles from './PressPage.module.css'
import { Helmet } from 'react-helmet-async'

import abc7 from 'assets/img/press/abc7.jpg'
import about from 'assets/img/press/about-com.jpg'
import adage from 'assets/img/press/ad-age.jpg'
import adweek from 'assets/img/press/adweek.jpg'
import ag from 'assets/img/press/ag.png'
import ap from 'assets/img/press/ap.png'
import bigdataDownload from 'assets/img/press/bigdata-download.jpg'
import bloombergTV from 'assets/img/press/bloomberg-tv.jpg'
import buzzfeed from 'assets/img/press/buzzfeed.png'
import caMeetingsServices from 'assets/img/press/california-meetings-services.jpg'
import cbsLA from 'assets/img/press/cbs-los-angeles.jpg'
import cheapOAir from 'assets/img/press/cheap-o-air.jpg'
import cnbc from 'assets/img/press/cnbc.jpg'
import datingAdvice from 'assets/img/press/dating-advice-com.jpg'
import destWeddingHoneymoon from 'assets/img/press/destination-weddings-honeymoons.jpg'
import flip from 'assets/img/press/flip.png'
import foodTruckNation from 'assets/img/press/food-truck-nation.jpg'
import forbes from 'assets/img/press/forbes.jpg'
import foxBusiness from 'assets/img/press/fox-business.jpg'
import fox2Detroit from 'assets/img/press/fox2-detroit.jpg'
import goodmorningAmerica from 'assets/img/press/goodmorning-america.gif'
import goop from 'assets/img/press/goop.jpg'
import hrExec from 'assets/img/press/hr-exec.jpg'
import huffpostTravel from 'assets/img/press/huffpost-travel.jpg'
import incRadio from 'assets/img/press/inc-radio.jpg'
import laBusinessJournal from 'assets/img/press/la-business-journal.jpg'
import laTimes from 'assets/img/press/la-times.jpg'
import mashable from 'assets/img/press/mashable.jpg'
import millenialMag from 'assets/img/press/millenial-mag.jpg'
import minnesotaMe from 'assets/img/press/minnesota-me.jpg'
import natGeo from 'assets/img/press/nat-geo.jpg'
import nyTimes from 'assets/img/press/ny-times.png'
import paste from 'assets/img/press/paste.jpg'
import philMagazine from 'assets/img/press/phil-magazine.jpg'
import qsr from 'assets/img/press/qsr.jpg'
import restaurantHospitality from 'assets/img/press/restaurant-hospitality.jpg'
import self from 'assets/img/press/self.jpg'
import stlToday from 'assets/img/press/stl-today.jpg'
import huffingtonPost from 'assets/img/press/the-huffington-post.jpg'
import washingtonPost from 'assets/img/press/the-washington-post.jpg'
import thrillist from 'assets/img/press/thrillist.jpg'
import xconomy from 'assets/img/press/xconomy.jpg'
import yahoo from 'assets/img/press/yahoo.jpg'

export default function PressPage() {
  const sliderItems = pressHighlights.map((item, index) => (
    <div key={index} className="p-4 md:w-1/3 md:pl-4 md:pr-4">
      <a href={item.url} target="_blank" className={[styles.slideArticle]}>
        <div
          className={styles.slider_bg}
          style={{
            backgroundImage: `url('${item.imageUrl}')`,
          }}
        ></div>
        <div className={styles.slider_hover}></div>
        <div className={styles.slider_content}>
          <h3 className="uppercase text-xs tracking-widest">{item.title}</h3>
          <p className="font-light">{item.description}</p>
        </div>
      </a>
    </div>
  ))

  return (
    <Layout className="container py-10">
      <TwoColumns sidebar={<Sidebar />}>
        <Helmet>
          <title>
            Press | Food Truck Marketing and Advertising Programs | Roaming Hunger
            - Roaming Hunger
          </title>
          <meta
            name="og:title"
            content="Press | Food Truck Marketing and Advertising Programs | Roaming Hunger"
          />
        </Helmet>
        <h2 className="text-gray-800 text-4xl font-platform leading-tight">
          Press
        </h2>
        <hr className="mb-4 mt-4" />
        <Slider
          slidesPerRow={3}
          rows={4}
          slidesToScroll={1}
          arrows={false}
          dots={false}
          responsive={[
            {
              breakpoint: 768,
              settings: {
                dots: false,
                arrows: false,
                slidesPerRow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 414,
              settings: {
                dots: false,
                arrows: false,
                slidesPerRow: 1,
                slidesToScroll: 1,
              },
            },
          ]}
        >
          {sliderItems}
        </Slider>
        <hr />
        <h2 className="text-navy text-3xl leading-tight">Media Contacts</h2>
        <p className="font-light text-sm">
          For high-resolution photos or more info, please contact:
          <br />
          <a
            className="text-blue hover:underline"
            href="mailto:press@roaminghunger.com"
          >
            press@roaminghunger.com
          </a>
        </p>
        <hr className="my-5" />
        <h2 className="text-navy text-3xl leading-tight">Social Media</h2>
        <ul className="font-light text-sm list-disc ml-10">
          <li>
            Facebook |{' '}
            <a
              className="text-blue hover:underline"
              href="https://www.facebook.com/roaminghunger"
            >
              facebook.com/roaminghunger
            </a>
          </li>
          <li>
            Twitter |{' '}
            <a
              className="text-blue hover:underline"
              href="https://twitter.com/roaminghunger"
            >
              @roaminghunger
            </a>
          </li>
          <li>
            Instagram |{' '}
            <a
              className="text-blue hover:underline"
              href="https://www.instagram.com/roaminghunger/"
            >
              @roaminghunger
            </a>
          </li>
          <li>
            Google+ |{' '}
            <a
              className="text-blue hover:underline"
              href="https://plus.google.com/+roaminghunger"
            >
              @roaminghunger
            </a>
          </li>
          <li>
            Pinterest |{' '}
            <a
              className="text-blue hover:underline"
              href="https://www.pinterest.com/roaminghunger"
            >
              pinterest.com/roaminghunger
            </a>
          </li>
        </ul>
      </TwoColumns>
    </Layout>
  )
}

const pressHighlights = [
  {
    url: 'https://www.foodtrucknation.us/',
    imageUrl: foodTruckNation,
    title: 'Food Truck Nation',
    description: 'U.S. Chamber of Commerce',
  },
  {
    url: 'https://www.fliprogram.com/best-cities-for-starting-a-food-truck-report',
    imageUrl: flip,
    title: 'FLIP',
    description: 'Best Cities to Start a Food Truck 2026',
  },
  {
    url: 'https://www.cheapoair.com/things-to-do/miami/cheap-eats-miami/',
    imageUrl: cheapOAir,
    title: 'CheapOAir',
    description: 'Where To Eat Cheap In Miami',
  },
  {
    url:
      'http://www.datingadvice.com/for-women/roaming-hunger-simplifies-the-search-for-food-trucks-to-enhance-romantic-nights',
    imageUrl: datingAdvice,
    title: 'Dating Advice',
    description: 'Weddings',
  },
  {
    url:
      'http://www.buzzfeed.com/juliareinstein/coachella-eats-2016?utm_term=.whoPPr7zj#.ctPXXxv6q',
    imageUrl: buzzfeed,
    title: 'Buzzfeed',
    description:
      "23 Insanely Tasty Foods From Coachella That'll Make You Hungry",
  },
  {
    url:
      'http://www.forbes.com/sites/geoffwilliams/2016/02/29/food-trucks-fyi-your-questions-about-owning-one-answered/#72dff3a41844',
    imageUrl: forbes,
    title: 'Forbes.com',
    description: 'Food Trucks FYI: Your Questions About Owning One Answered',
  },
  {
    url:
      'http://www.latimes.com/food/dailydish/la-dd-food-trucks-20160620-snap-story.html',
    imageUrl: laTimes,
    title: 'Los Angeles Times',
    description:
      'Today is the first official National Eat at a Food Truck Day. You ready?',
  },
  {
    url:
      'http://adage.com/article/cmo-strategy/lowdown-microsoft-tops-breakthrough-ad-ranking/303431/',
    imageUrl: adage,
    title: 'Advertising Age',
    description: 'Lowdown: Microsoft Tops â€˜Breakthroughâ€™ Ad Ranking',
  },
  {
    url:
      'http://losangeles.cbslocal.com/2016/05/18/wedding-week-a-look-at-some-unconventional-and-cheaper-food-options/',
    imageUrl: cbsLA,
    title: 'CBS Los Angeles',
    description:
      'Wedding Week: A Look At Some Unconventional (And Cheaper) Food Options',
  },
  {
    url:
      'http://www.foxbusiness.com/features/2016/05/06/7-surprising-ways-to-save-big-money-on-your-wedding.html',
    imageUrl: foxBusiness,
    title: 'Fox Business',
    description: '7 Surprising Ways to Save Big Money on Your Wedding',
  },
  {
    url: 'http://www.destinationweddingmag.com',
    imageUrl: destWeddingHoneymoon,
    title: 'Destination Weddings & Honeymoons',
    description: 'Trend Alert: Festive Food Trucks',
  },
  {
    url:
      'http://hosted2.ap.org/COGRA/a1210881e1db47d69e4869ba913e6100/Article_2015-03-05-US--Travel-Trip-Essentials-Los%20Angeles/id-e1052b4c00804503882540beb50f7665',
    imageUrl: ap,
    title: 'Associated Press',
    description: "Essentials for Visiting LA: What's New, Classics and More",
  },
  {
    url:
      'http://www.nytimes.com/2015/04/12/fashion/weddings/where-to-rent-an-elephant.html',
    imageUrl: nyTimes,
    title: 'New York Times',
    description: 'Where to Rent an Elephant',
  },
  {
    url:
      'http://www.adweek.com/news/advertising-branding/company-went-selling-street-meat-saks-fifth-avenue-158290',
    imageUrl: adweek,
    title: 'Adweek',
    description:
      'This Company Went From Selling Street Meat to Saks Fifth Avenue',
  },
  {
    url: 'https://www.thrillist.com/eat/los-angeles/history-of-la-food-trucks',
    imageUrl: thrillist,
    title: 'Thrillist',
    description: 'History of LA Food Trucks',
  },
  {
    url: 'http://goop.com/city-guide/the-party-planning-guide/online/',
    imageUrl: goop,
    title: 'Goop',
    description: 'The Party Planning Guide',
  },
  {
    url:
      'http://www.huffingtonpost.com/bailey-gaddis/a-foodies-guide-to-austin_b_9853616.html',
    imageUrl: huffpostTravel,
    title: 'HuffPost Travel',
    description: 'A Foodieâ€™s Guide To Austin, Texas',
  },
  {
    url:
      'http://www.meetingsmags.com/it-time-planners-update-their-playbooks-engage-silicon-beach',
    imageUrl: caMeetingsServices,
    title: 'California Meetings + Events',
    description:
      'It Is Time For Planners To Update Their Playbooks & Engage In Silicon Beach',
  },
  {
    url:
      'http://ngm.nationalgeographic.com/print/2015/07/food-trucks/brindley-text',
    imageUrl: natGeo,
    title: 'National Geographic ',
    description: 'On A Roll',
  },
  {
    url:
      'https://www.qsrmagazine.com/outside-insights/how-leverage-technology-food-truck-success',
    imageUrl: qsr,
    title: 'QSR Magazine',
    description: 'How to Leverage Technology for Food-Truck Success',
  },
  {
    url:
      'http://www.labusinessjournal.com/news/2015/jan/29/worklife-ross-resnick/',
    imageUrl: laBusinessJournal,
    title: 'Los Angeles Business Journal',
    description: 'Work/Life: Ross Resnick',
  },
  {
    url:
      'https://gma.yahoo.com/6-apps-summer-travel-much-better-234100316--abc-news-travel.html',
    imageUrl: goodmorningAmerica,
    title: 'Good Morning America',
    description: '6 Apps to Make Summer Travel So Much Better',
  },
  {
    url:
      'http://www.latimes.com/business/la-fi-roaming-hunger-20150422-story.html',
    imageUrl: laTimes,
    title: 'Los Angeles Times',
    description:
      "As food truck craze fades, Roaming Hunger helps boost vendors' profits ",
  },
  {
    url: 'http://mashable.com/2015/11/04/foodie-apps/#swvIhfgfCuqb',
    imageUrl: mashable,
    title: 'Mashable',
    description: '15 Apps Every Foodie Must Have on Their Phone',
  },
  {
    url:
      'http://www.phillymag.com/philadelphia-wedding/2015/01/22/local-bridal-guide-5-philly-food-trucks-wedding-guest-will-go-crazy/',
    imageUrl: philMagazine,
    title: 'Philly Magazine',
    description:
      'Local Bridal Guide: 5 Philly Food Trucks Your Wedding Guests will Go Crazy For',
  },
  {
    url:
      'http://foodbeverage.about.com/od/Whats_Hot/fl/Get-the-Latest-On-the-Food-Truck-Trend.htm',
    imageUrl: about,
    title: 'About.com',
    description: 'Get the Latest food Truck Trend',
  },
  {
    url:
      'http://www.stltoday.com/lifestyles/next-big-budget-wedding-idea-food-trucks/article_68eb92d9-4491-5e0a-80b0-4bbf698fd523.html',
    imageUrl: stlToday,
    title: 'St. Louis Post-Dispatch',
    description: 'Next Big Budget Wedding Idea: Food Trucks',
  },
  {
    url:
      'http://www.pastemagazine.com/articles/2015/01/what-does-it-take-to-launch-a-food-truck.html',
    imageUrl: paste,
    title: 'Paste Magazine',
    description: 'What Does It Take to Launch a Food Truck',
  },
  {
    url:
      'http://www.cnbc.com/2015/11/20/food-trucks-cooking-up-restaurant-empires.html',
    imageUrl: cnbc,
    title: 'CNBC',
    description: 'Food Trucks Cooking Up Restaurant Empires',
  },
  {
    url:
      'http://abc7.com/food/garth-kemp-cooks-with-wicked-kitchen-for-la-food-truck-week/344958/',
    imageUrl: abc7,
    title: 'KABC',
    description:
      'Garth Kemp Dons Apron, Joins Wicked Kitchen for Food Truck Week LA',
  },
  {
    url:
      'http://millennialmagazine.com/ross-resnick-makes-food-trucks-popular-with-roaming-hunger/',
    imageUrl: millenialMag,
    title: 'Millennial Magazine',
    description: 'Ross Resnick Makes Food Trucks Popular with Roaming Hunger',
  },
  {
    url:
      'http://www.ernlive.com/show/inc-radio/15335/episodes/vintage-guitars-and-food-trucks-full-episode-18-2',
    imageUrl: incRadio,
    title: 'Inc. Radio',
    description: 'Vintage Guitars and Food Trucks',
  },
  {
    url: 'http://www.androidguys.com/2014/11/18/roaming-hunger-debuts-android/',
    imageUrl: ag,
    title: 'Android Guys',
    description: 'Roaming Hunger Debuts on Android',
  },
  {
    url:
      'http://www.self.com/body/food/2014/08/healthy-food-trucks-exist-theyre-delicious-slideshow/1',
    imageUrl: self,
    title: 'Self.com',
    description: "Healthy Food Trucks? They Exist, and They're Delicious",
  },
  {
    url:
      'http://finance.yahoo.com/blogs/big-data-download/food-trucks-moving-in-on-restaurants--territory-121936228.html',
    imageUrl: bigdataDownload,
    title: 'Yahoo! Finance: Big Data Download',
    description: "Food trucks moving in on restaurants' territory",
  },
  {
    url: 'http://blog.hreonline.com/2014/10/23/keep-food-truckin/',
    imageUrl: hrExec,
    title: 'Human Resources Executive Online',
    description: "Keep on (Food) Truckin'",
  },
  {
    url:
      'http://www.huffingtonpost.com/britt-hysen/the-power-of-millennial-e_b_5801322.html',
    imageUrl: huffingtonPost,
    title: 'Huffington Post',
    description: 'The Power of Millennial Entrepreneurship',
  },
  {
    url:
      'http://www.bloomberg.com/news/videos/b/f7d54dc1-1406-4e54-b337-eb7c6e41f894',
    imageUrl: bloombergTV,
    title: 'Bloomberg Television',
    description: 'Roaming Hunger: Food Trucks at Your Fingertips',
  },
  {
    url:
      'http://restaurant-hospitality.com/food-trucks/food-truck-rentals-new-strategies',
    imageUrl: restaurantHospitality,
    title: 'Restaurants Hospitality',
    description: 'Food Truck Rentals: The New Strategies',
  },
  {
    url:
      'http://mn.meetingsmags.com/food-trucks-keep-everyone-smiling-including-planners',
    imageUrl: minnesotaMe,
    title: 'Minnesota Meetings + Events',
    description: 'Food Trucks Keep Everyone Smiling, Including Planners',
  },
  {
    url:
      'https://www.yahoo.com/travel/how-social-media-will-save-you-money-and-make-you-a-101368692697.html',
    imageUrl: yahoo,
    title: 'Yahoo!',
    description:
      'How Social Media Will Save you Money and Make You a Rock Star Traveler',
  },
  {
    url:
      'http://www.myfoxdetroit.com/story/27386140/how-to-find-the-closest-food-truck-to-you-in-detroit',
    imageUrl: fox2Detroit,
    title: 'Fox 2 Detroit',
    description: 'How to find the closest food truck to you in Detroit',
  },
  {
    url:
      'http://www.washingtonpost.com/lifestyle/food/as-the-upstart-food-truck-industry-matures-where-is-dcs-mobile-lunch-scene-headed/2014/07/28/0a2f1f42-0e99-11e4-8c9a-923ecc0c7d23_story.html',
    imageUrl: washingtonPost,
    title: 'Washington Post',
    description:
      "As the upstart food truck industry matures, where is D.C.'s mobile lunch scene headed?",
  },
  {
    url:
      'http://www.xconomy.com/national/2013/01/04/10-apps-that-will-make-you-feel-smarter-more-cultured-in-2013/',
    imageUrl: xconomy,
    title: 'Xconomy',
    description:
      '10 Apps That Will Make You Feel Smarter & More Cultured in 2013 ',
  },
]
